<script setup lang="ts">
import appIconUrl from '../assets/povli-app-icon-96.webp'
</script>

<template>
  <div class="inline-flex items-center gap-2" aria-label="Povli">
    <img :src="appIconUrl" alt="" class="size-8 rounded-[10px] object-cover shadow-sm" />
    <span class="font-serif text-[1.4rem] font-semibold tracking-[-0.04em] text-ink">Povli</span>
  </div>
</template>
